<adm-loading-spinner [loadingSignal]="state.loading()"></adm-loading-spinner>

@if ((appState.isInErrorState$ | async) === false) {
  @if ((appState.isInErrorState$ | async) === false) {
    <div class="list" [class.loading-blur]="state.loading()" [class.loading-blur--done]="!state.loading()">
      <div
        class="list__unit-header list__unit-header--fixed"
        matSort
        (matSortChange)="sortData($event)"
        [style.--list-unit-header-top]="appState.cssVarListUnitHeaderTop + 'px'"
        [style.--list-unit-header-translate-x]="appState.cssVarListUnitHeaderTranslateX + 'px'">
        <div class="col col--userName" mat-sort-header="userName">Brugernavn</div>
        <div class="col col--fullName" mat-sort-header="firstName">Navn</div>
        <div class="col col--organizationName" mat-sort-header="organizationName">Organisation</div>
        <div class="col col--roles" mat-sort-header="roles">Rolle(r)</div>
        <div class="col col--departmentRestrictions" mat-sort-header="departmentRestrictions">Afdelingsbegrænsning</div>
        <div class="col col--updated" mat-sort-header="updated">Ændret</div>
        <div class="col col--updatedBy" mat-sort-header="updatedBy">Ændret af</div>
        <div class="col col--actions"></div>
      </div>
      @for (user of usersData().items; track $index) {
        <adm-user-row
          [user]="user"
          (refreshAfterUpdateEvent)="refreshAfterUpdate($event)"
          (refreshAfterDeleteEvent)="refreshAfterDelete($event)"></adm-user-row>
      }
    </div>
  }
  @if (usersData().items.length === 0 && !state.loading()) {
    <div class="no-results align-center">
      <p>Der blev ikke fundet nogen brugere</p>
    </div>
  }
  <mat-paginator
    #paginator
    [pageSize]="state.viewState().page.pageSize"
    [pageIndex]="state.viewState().page.pageIndex"
    [length]="usersData().totalCount"
    [pageSizeOptions]="state.pagingOptions()"
    (page)="pageSwitch($event)"
    color="accent"
    [disabled]="state.loading()"></mat-paginator>
}
